import * as React from 'react';
import { ReactElement } from 'react';

import styles from './Table.module.css';

interface Props {
  items?: object[];
  renderBodyRow?: (item: object) => ReactElement;
  renderHeaderRow?: () => ReactElement;
  children?: ReactElement[];
}

const Table: React.FunctionComponent<Props> = ({
  items,
  renderBodyRow,
  renderHeaderRow,
  children,
}) => (
  <table className={styles.tableContainer}>
    {renderHeaderRow && <thead>{renderHeaderRow()}</thead>}
    {renderBodyRow && <tbody>{items.map(renderBodyRow)}</tbody>}
    {children && <tbody>{children}</tbody>}
  </table>
);

Table.defaultProps = {
  renderHeaderRow: () => null,
};
Table.displayName = 'Table';

export default Table;
